import { createContext, ReactNode, useContext } from "react";
import {
  BookingCartStore,
  CartState,
  useBookingCartStore,
  useVoucherBookingCartStore,
} from "./bookingCart";

// Context che identifica QUALE dei due store del booking cart usare
// (normale vs voucher) in tutto il sottoalbero React del flusso booking.
// Default fuori dal Provider: store normale (per i componenti globali tipo
// la navbar che mostrano sempre il cart "principale").
const BookingCartStoreContext = createContext<BookingCartStore>(
  useBookingCartStore,
);

export function BookingCartProvider({
  isVoucherBooking,
  children,
}: {
  isVoucherBooking: boolean;
  children: ReactNode;
}) {
  const store = isVoucherBooking
    ? useVoucherBookingCartStore
    : useBookingCartStore;
  return (
    <BookingCartStoreContext.Provider value={store}>
      {children}
    </BookingCartStoreContext.Provider>
  );
}

// Hook usato dai consumer dentro il flusso booking. Restituisce il hook
// dello store giusto secondo il context. Si usa esattamente come l'hook
// Zustand: `const { bookingCart } = useBookingCart()` o con selector.
export function useBookingCart(): CartState;
export function useBookingCart<T>(selector: (state: CartState) => T): T;
export function useBookingCart<T>(
  selector?: (state: CartState) => T,
): T | CartState {
  const store = useContext(BookingCartStoreContext);
  return selector ? store(selector) : store();
}

// Variante di comodo per componenti che hanno solo bisogno di sapere
// quale store è quello "attivo" senza leggere uno stato specifico.
export function useBookingCartStoreFromContext(): BookingCartStore {
  return useContext(BookingCartStoreContext);
}
